import {
  ControllerGlobals,
  genericXHRErrorHandler,
  getAuthHeader,
  globalNeedToSetTheScale,
  MODKEYS_STATE,
  toastErrorSingle,
  toastInfo,
  toastRemoveAll
} from "src/components/Planner/controller";
import {
  doesDeviceFitRoom,
  infiniteLineIntersection,
  P_numtoxy,
  snapAngleTo45_2,
  snapDeviceToWall,
  uMath,
  vectorRotationDegree
} from "src/components/Planner/planner/uMath";
import { drawSnapLines, snapDeviceToNearby } from "src/components/Planner/planner/deviceGeometry";
import {wallModHelper} from "src/components/Planner/planner/wallModHelper";
import {
  devicesOfSerial,
  devicesOfSerialConnection,
  getDeviceById,
  getDistinctGroupsOfDevs,
  getGroupsOfD,
  getRoomById,
  getSerialById,
  isDInGroup,
  isPointOutOfBounds,
  rebuildWallsCache,
  thereWasGhostDevice,
  uDev,
  whichRoomIsPointInInclOutdoorsAndUnassigned
} from "src/components/Planner/planner/uDev";
import { canBeDevMerged, getProductOfDevice, uDevDOM } from "src/components/Planner/planner/uDev-dom";
import $ from "jquery";
import * as d3 from "d3";
import {redrawGhostNote} from "src/components/Planner/planner/notes";
import {
  drawDraggedMotionSensor,
  isCamera,
  isMotionSensorOrCamera,
  showNoMotionSensorError
} from "src/components/Planner/planner/movsen";
import {ROOT_URI} from "src/utils/constants";
import {
  dragDrawTempMeasurements,
  draw_measureMeMove,
  filterInvalidMeasurements,
  isDInMeasures,
  measureHelper,
  redrawMeasurements,
  redrawMeasurementsOf
} from "src/components/Planner/planner/measurement";
import {
  GroupingGlobals,
  recalcSwitchPNIDs,
  redrawGroups,
  showGroupInvalidMsgIfAnyIsInvalid
} from "src/components/Planner/planner/grouping";
import { isAP } from "src/components/Planner/planner/wificalc";
import { calcAndShowWifiHeatmap, removeWifiHeatmap, tryShowWifiTip } from "src/components/Planner/planner/wificalc-dom";
import {ts, ts2} from "src/utils/translate";
import { getSerialConnectionForSerialId, serialsConnectable } from "src/components/Planner/planner/serialConnections";
import {
  connectSerials,
  getOverlappingSerials,
  highlightSerial,
  mergeSerials,
  shadowOverlappingSerials
} from "src/components/Planner/planner/serialConnections-dom";
import {ConnectSerialsAction} from "src/components/Planner/planner/history/serconn-actions";
import {MergeSerialsAction, MoveDeviceAction} from "src/components/Planner/planner/history/device-actions";
import {DeviceDrawingGlobals, redrawDevices} from "src/components/Planner/planner/deviceDrawing";
import {
  addErrorMarker,
  addNormalModdedDev,
  addProblemDevice,
  anyRoomContainsDeviceAllpts,
  areProblemsFixed,
  changeWall,
  d3DataWithSnappedPosOverride,
  dataFromDeviceD,
  devicesChanged,
  disablePlannerButtonsExcept,
  dNoPermission,
  drawLengthLine,
  enablePlannerButtons,
  enderrorCorrectMode,
  getNodeForD3Data,
  getXY,
  getXYP,
  hideTools,
  highlightDeviceNoZoom,
  highlightNextProblematic,
  isDevCabinet,
  isDeviceInIntendedRoom,
  isInProblemDevices,
  isPlannerMetric,
  modifyWallOtherPoint,
  problemDevsCount,
  PUTDevData,
  redrawD3DevExtras,
  redrawGhostDevice,
  redrawModifyPolyline,
  removeErrorMarker,
  removeGhostDevice,
  removeLengthLines,
  removeProblemDevice,
  saveCurrAngle,
  saveCurrDevicePos,
  showCurrLeftouts,
  snapCurrDeviceBack,
  twoClosestWallsWithPoints,
  unHighlight,
  updateD3MergedDevs,
  updateDragXY,
  writeDevParams
} from "src/components/Planner/planner/planner";
import { PlannerGlobals } from "src/components/Planner/planner/planner-globals";
import { getDColsNum, getDRowsNum } from "src/components/Planner/planner/serial-layout";
import {isCategoryLocked} from "src/components/Planner/planner/categoryDisplayHandler";
import {floorProvider} from "src/components/Planner/planner/FloorProvider";
import {DragPreviewState, setActiveDragPreviewState} from "src/components/Planner/planner/dragPreview";

let _dragDropCallbacks = { onFrameAction: null };

export function setDragDropCallbacks({ onFrameAction }) {
  _dragDropCallbacks.onFrameAction = onFrameAction;
}

export function mergeFrames(thisId, otherId, height, direction) {
  return mergeSerials(thisId, otherId).then((newDevIds) => {
    const action = new MergeSerialsAction(thisId, otherId, newDevIds, height, direction);
    PlannerGlobals.plannerHistoryManager.addHistoryEntry(action);
  });
}

export function connectFrames(thisId, otherId) {
  return connectSerials(thisId, otherId).then((result) => {
    const action = new ConnectSerialsAction(thisId, otherId, result.prePos);
    PlannerGlobals.plannerHistoryManager.addHistoryEntry(action);
  });
}

export function roomCircleDragHandler(event, d) {
  updateDragXY(event);
  disablePlannerButtonsExcept();
  //redrawing
  changeWall(d, true);
  var xy = getXY();
  d.x = xy[0];
  d.y = xy[1];

  if (MODKEYS_STATE.shift && PlannerGlobals.draggedWall) {
    var newpt = uMath.getSnappedEnd(
        {x: PlannerGlobals.draggedWall.x, y: PlannerGlobals.draggedWall.y},
        {x: d.x, y: d.y});
    var otherWall = modifyWallOtherPoint(d);
    var rot = vectorRotationDegree(otherWall, newpt);
    var snapped = snapAngleTo45_2(rot);
    if (wallModHelper.angleSimilar(rot, snapped, 4)) {
      var l1 = uMath.segmentFromPoints(PlannerGlobals.draggedWall, newpt);
      var corrPt = uMath.pointAtAngleDistance(otherWall, snapped, 10);
      var l2 = uMath.segmentFromPoints(otherWall, corrPt);
      /* var v1 = uMath.vectorFromSegment(l1);
            var v2 = uMath.vectorFromSegment(l2);
            var vrot = uMath.vectorAngle(v1, v2); */
      var intersect = infiniteLineIntersection(l1, l2);
      if (intersect.x && intersect.y && intersect.x < 900 && intersect.y < 900
          && intersect.x > 0 && intersect.y > 0) {
        d.x = intersect.x;
        d.y = intersect.y;
      } else {
        d.x = newpt.x;
        d.y = newpt.y;
      }
    } else {
      d.x = newpt.x;
      d.y = newpt.y;
    }
  }
  d.tx = d.x;
  d.ty = d.y;

  redrawModifyPolyline();

  showCurrLeftouts();
}

export function testIfDraggableSerial(d) {
  if (Array.isArray(d.devices)) {
    if (d.devices.every(function (dev) {
      return dev.dragTestInProgress || typeof dev.nopermission != "undefined";
    })) {
      return;
    }

    d.dragTestInProgress = true;
    saveCurrDevicePos(d);
    var hasSnappedBack = false;

    d.devices.forEach(function (dev) {
      if (typeof dev.nopermission != "undefined" && !dev.nopermission
          || dev.dragTestInProgress) {
        return;
      }
      dev.dragTestInProgress = true;
      var sendURL = ROOT_URI + '/device';
      var sendData = {
        x: d.x, y: d.y,
        room_id: d.roomId,
        plan_object_id: dev.deviceId.toString(),
        rotate_value: d.angle
      };
      getAuthHeader(function (header) {
        $.ajax({
          headers: header,
          url: sendURL,
          type: 'PUT',
          data: sendData,
          success: function (response) {
            dev.nopermission = false;
            d.nopermission = false;
          },
          error: function (response) {
            dev.nopermission = true;
            d.nopermission = true;
            dev.nopermissionmsg = genericXHRErrorHandler(response, true);
            $('[data-deviceToolId="' + dev.deviceId + '"]').remove();
            if (!hasSnappedBack) {
              hasSnappedBack = true;
              snapCurrDeviceBack(d);
              removeGhostDevice();
              removeLengthLines();
              redrawMeasurements();
              redrawGroups();
            }
          }
        });
      });
    });
  }
}

export function testIfDraggable(d) {
  if (PlannerGlobals.mode != 'basic') {
    return;
  }
  if (d.devices.length === 1) {
    var dev = d.devices[0];
    if (typeof dev.nopermission != "undefined" && !dev.nopermission
        || dev.dragTestInProgress) {
      return;
    }
    var isCabinet = 'type' in dev && dev.type.toString().indexOf("cabinet")
        != -1;
    var isCustom = dev.deviceId.toString().indexOf("C_") == 0;
    var sendURL = ROOT_URI + '/device';
    var sendData = {
      x: d.x, y: d.y,
      room_id: d.roomId,
      plan_object_id: dev.deviceId.toString().replace('S_', ''),
      rotate_value: d.id ? d.angle : d.devices[0].angle
    };

    if (isCabinet) {
      sendURL = ROOT_URI + '/floor/additional-item';
      delete sendData.plan_object_id;
      sendData.additional_item_id = dev.deviceId.toString().replace('S_', '');
      sendData.item_type = dev.item_type;
    }

    if (isCustom) {
      sendURL = ROOT_URI + "/user-custom-items/room-user-custom-item";
      delete sendData.plan_object_id;
      sendData.room_user_custom_item_id = dev.deviceId.toString().replace("C_",
          "");
      sendData.user_custom_item_id = dev.user_custom_item_id;
    }

    // TODO: REMOVE THIS AFTER UNASSIGNED AJAX
    /* if (sendData.room_id == uDev.UNASSIGNED_ROOM_ID) {
            console.debug('DEBUG: Replaced unassigned room id with outdoor room id');
            sendData.room_id = uDev.OUTDOORS_ROOM_ID;
        } */

    saveCurrDevicePos(d);
    dev.dragTestInProgress = true;
    getAuthHeader(function (header) {
      $.ajax({
        headers: header,
        url: sendURL,
        type: 'PUT',
        data: sendData,
        success: function (response) {
          dev.nopermission = false;
        },
        error: function (response) {
          if (response.statusText === "error") {
            dev.dragTestInProgress = false;
          } else {
            dev.nopermission = true;
            dev.nopermissionmsg = genericXHRErrorHandler(response, true);
          }
          $('[data-deviceToolId="' + dev.deviceId + '"]').remove();
          snapCurrDeviceBack(d);
          removeGhostDevice();
          removeLengthLines();
          redrawMeasurements();
          redrawGroups();
        }
      });
    });
  } else {
    testIfDraggableSerial(d);
  }
}

export function dragShiftUpHandler(e) {
  var d = PlannerGlobals.DRAG_HELPER.draggedD3Dev;
  if (e.key == "Shift" && d) {
    dragHandleCore(d);

  }
  $(document).on('keydown', dragShiftDownHandler);
}

export function dragShiftDownHandler(e) {
  $(document).off('keydown', dragShiftDownHandler);
  if (e.key == "Shift") {

    if (thereWasGhostDevice()) {
      removeGhostDevice();
    }

    removeLengthLines();

    var d = PlannerGlobals.DRAG_HELPER.draggedD3Dev;

    if (d) {
      dragHandleCore(d);
    }
  }
}

/**
 *
 * @param {D3Device} d
 */
export function dragstarted(event, d) {
  PlannerGlobals.hasDraggedDev = false;
  redrawMeasurements();
  if (PlannerGlobals.mode == "measurePrepare") {
    measureHelper.startMeasure(d);
    return;
  } else if (['measureMe', 'wificalc', 'modifyOuterW', 'selectRoom'].indexOf(
      PlannerGlobals.mode) !== -1) {
    return;
  }
  rebuildWallsCache(null, true, true);
  removeWifiHeatmap();
  if (PlannerGlobals.LIGHTING_CALC) {
    PlannerGlobals.LIGHTING_CALC.stopLightCalcMode();
  }
  drawDraggedMotionSensor(d.devices[0]);

  if (dNoPermission(d)) {
    toastErrorSingle(d.devices[0].nopermissionmsg || ts('p_drag_permission',
        "You don't have permission to drag this device."));
  }

  PlannerGlobals.DRAG_HELPER.dragStartMode = PlannerGlobals.mode;
  PlannerGlobals.selectionBeforeDrag = PlannerGlobals.currentlySelectedElement;
  PlannerGlobals.DRAG_HELPER.dragStartRoomId = d.roomId;
  var cursorXY = getXYP();
  PlannerGlobals.DRAG_HELPER.deviceCursorDiff = {
    x: cursorXY.x - d.x,
    y: cursorXY.y - d.y
  };
  d.dragStartRoomId = d.roomId;
  unHighlight();
  var serDevs = devicesOfSerialConnection(d) || devicesOfSerial(d.id)
      || d.devices;
  for (var i = 0; i < serDevs.length; i++) {
    if (serDevs[i].ghost) {
      d.haunted = true;
      PlannerGlobals.panDisable = true;
      return;
    }
    if (isCategoryLocked(serDevs[i].category_id)) {
      d.dragdisabled = true;
      PlannerGlobals.panDisable = true;
      return;
    }
    if (serDevs[i].nopermission) {
      PlannerGlobals.panDisable = true;
      return;
    }
  }

  d.haunted = false;
  d.dragdisabled = false;

  var grps = getGroupsOfD(d);
  grps.forEach(function (group) {
    if (GroupingGlobals.groupRecalcTimeouts[group.id]) {
      console.debug(`canceling recalc grp ${group.id}`);
      clearTimeout(GroupingGlobals.groupRecalcTimeouts[group.id]);
    }
  });

  if (PlannerGlobals.mode == 'basic'
      || PlannerGlobals.plannerEditableWallViewEnable === true) {
    d.runDragHandleOnce = true;
    PlannerGlobals.svg.selectAll('.note-tool').remove();
    testIfDraggable(d);
    saveCurrDevicePos(d);
    saveCurrAngle(this);
    PlannerGlobals.outOfRoomAlertShown = false;
    // isDragging = true;
    PlannerGlobals.DRAG_HELPER.draggedD3Dev = d;
    PlannerGlobals.DRAG_HELPER.draggedD3This = this;
    $(document).on('keyup', dragShiftUpHandler);
    $(document).on('keydown', dragShiftDownHandler);
    PlannerGlobals.currentPoly = getRoomById(d.roomId).poly.map(function (XY) {
      return [XY.x, XY.y];
    });
    event.sourceEvent.stopPropagation();
    d3.select(this).classed("dragging", true);
    $('#svgAndChat').find('.important-msg-container').remove();
    if (!PlannerGlobals.LENGTHOF1PX && isMotionSensorOrCamera(d.devices[0])) {
      showNoMotionSensorError();
    }
    tryShowWifiTip();
  }
}

/**
 *
 * MEGLÉVŐ elem mozgatása
 *
 * @param {D3Device} d
 */
export function dragHandleCore(d) {
  var snappedPos;
  var dev = d.devices[0];

  // events to run only once per drag, but not on mousedown, but when the element gets dragged
  if (d.runDragHandleOnce) {
    d.runDragHandleOnce = false;

    // highlight connectables
    dragHighlightConnectables(d);

    // hide height numbers
    getNodeForD3Data(d).selectAll('.height-txt, .height-txt-rect').style(
        'display', 'none');
  }

  // snapping (disabled if shift is pressed or is camera or has VALID overlap)
  if (MODKEYS_STATE.shift /* || overlaps.length */) {
    removeGhostDevice();
  } else {
    snappedPos = dragTrySnapDev(snappedPos, d, dev);
  }

  // get overlaps
  const overlaps = getOverlappingSerials(
      d3DataWithSnappedPosOverride(snappedPos, d));
  shadowOverlappingSerials(overlaps.slice(0, 1), d);

  // redraw length from point to closest walls
  if (PlannerGlobals.measurements_on) {
    dragDrawTempMeasurements(snappedPos, d);
  }

  // redraw groups and measurements in case dev is in either of them
  if (++PlannerGlobals.CURR_REDRAW_COUNTER % PlannerGlobals.CAN_REDRAW_EVERY_FRAME == 0) {
    if (isDInGroup(d)) {
      redrawGroups(true, d);
    }
    if (isDInMeasures(d)) {
      redrawMeasurementsOf(d);
    }
    if (PlannerGlobals.wifibtn_exists && PlannerGlobals.LENGTHOF1PX && PlannerGlobals.mode
        != 'wificalc' && isAP(d.devices.map(function (dev) {
          return dev.product_name_id;
        }))) {
      calcAndShowWifiHeatmap(25);
    }
    PlannerGlobals.CURR_REDRAW_COUNTER = 0;
  }

  // redraw motion sensor radius (if it is one)
  drawDraggedMotionSensor(d.devices[0]);
  // decide if new position is valid
  doDragChecks(d, overlaps);
  var isInRoom = isDeviceInIntendedRoom(d);
  if (isInRoom || overlaps.length || thereWasGhostDevice()) {
    removeErrorMarker(d);
    if (PlannerGlobals.sizeErrorHelper.errorCorrectMode) {
      removeProblemDevice(d);
    }
  } else if (!isInRoom) {
    addErrorMarker(d);
    if (PlannerGlobals.sizeErrorHelper.errorCorrectMode) {
      addProblemDevice(d);
    }
  }
}

export function dragTrySnapDev(snappedPos, d, dev) {
  const colsNum = getDColsNum(d);
  const rowsNum = getDRowsNum(d);
  const biggerDimNum = Math.max(colsNum, rowsNum);
  snappedPos = snapDeviceToNearby(d, getProductOfDevice(dev), true);
  if (!snappedPos) {
    snappedPos = snapDeviceToWall(dev,
        PlannerGlobals.DEVICE_SIZE * 1.2 + (biggerDimNum - 1)
        * PlannerGlobals.DEVICE_SIZE * 0.55, colsNum,
        true, undefined, undefined, undefined, undefined, rowsNum);
  }
  if (snappedPos && !(isDevCabinet(dev) && snappedPos.room.id
      === uDev.OUTDOORS_ROOM_ID)) {
    redrawGhostDevice(snappedPos.point, snappedPos.rotation, snappedPos.room,
        colsNum, d, rowsNum);
    d.roomId = snappedPos.room.id;
    d.devices.forEach(function (dev) {
      dev.roomId = d.roomId;
    });
  } else {
    snappedPos = null;
    removeGhostDevice();
  }
  return snappedPos;
}

export function dragHighlightConnectables(d) {
  if (d.id) {
    const currDevNum = getSerialById(d.id).deviceIds.length;
    PlannerGlobals.serials
    .filter(function (otherSerial) {
      return otherSerial.id != d.id && (otherSerial.deviceIds.length
          + currDevNum <= 4 || serialsConnectable(d.id, otherSerial.id));
    })
    .forEach(function (otherSerial) {
      let fillColor, strokeColor;
      const mergeable = otherSerial.deviceIds.length + currDevNum <= 4;
      const connectable = serialsConnectable(d.id, otherSerial.id);
      if (mergeable && connectable) {
        fillColor = 'url(#MergeConnectGradient)';
        strokeColor = 'url(#MergeConnectGradient)';
      } else if (mergeable) {
        fillColor = 'rgb(0, 220, 44)';
        strokeColor = 'rgba(2, 86, 0, 0.98)';
      } else if (connectable) {
        fillColor = '#2196f36e';
        strokeColor = '#2196f3ad';
      }
      highlightSerial(otherSerial.id, fillColor, strokeColor, true);
    });
  }
}

/**
 *
 * @param {D3Device} d
 */
export function dragdev(event, d) {

  updateDragXY(event);
  if (PlannerGlobals.mode == 'measureMe') {
    draw_measureMeMove();
    return;
  }
  showDragAndDropOverlay(false);

  if (ControllerGlobals.currentlyDraggedDevice || !d || d.dragdisabled
      || !PlannerGlobals.DRAG_HELPER.draggedD3This
      || !PlannerGlobals.DRAG_HELPER.deviceCursorDiff) {
    return;
  }

  PlannerGlobals.hasDraggedDev = true;

  if (PlannerGlobals.mode != 'modifyOuterW' && PlannerGlobals.mode
      != 'selectRoom' && !d.id) {
    unHighlight();
  }
  var dev = d.devices[0];
  if (
      (PlannerGlobals.mode == 'basic' && !dNoPermission(d) && !d.haunted)
      || (PlannerGlobals.plannerEditableWallViewEnable === true
          && !dNoPermission(d) && !d.haunted)
  ) {

    disablePlannerButtonsExcept();

    if (dev.mergeable === true) {
      $('.productId' + dev.product_id).addClass('merged-highlight');
      //saját magárol leszedjük
      $('#devicesMain').find(`[data-deviceId="${dev.deviceId}"]`).removeClass(
          'merged-highlight');
    }

    var xyCursor = getXYP();
    d.x = xyCursor.x - PlannerGlobals.DRAG_HELPER.deviceCursorDiff.x;
    d.y = xyCursor.y - PlannerGlobals.DRAG_HELPER.deviceCursorDiff.y;
    d.devices.forEach(function (dev) {
      dev.x = d.x;
      dev.y = d.y;
    });

    // attributes end
    dragHandleCore(d);

    // setting dev translate to new position
    d3.select(PlannerGlobals.DRAG_HELPER.draggedD3This).attr("transform",
        function (d) {
          return "translate(" + [d.x, d.y] + ")" + PlannerGlobals.DRAG_DEV_START_ROTATION;
        });

    // if dev moved more than 1 pixel, remove tools
    if (Math.pow((d.x - dev.origiposition[0]), 2) + Math.pow(
        (d.y - dev.origiposition[1]), 2) > 0.01) {
      hideTools();
      PlannerGlobals.svg.selectAll('.wall-tool').remove();
      d3.select('#rotate-tool').remove();
    }
  }

}

/**
 *
 * @param {D3Device} d D3 representation of a device/serial group
 * @param {Serial[]} overlaps
 * @returns {boolean} Returns whether the device is in a valid place
 */
export function doDragChecks(d, overlaps) {
  var foundValidRoom = anyRoomContainsDeviceAllpts(d);
  if (!foundValidRoom && !thereWasGhostDevice() && !overlaps.length) {
    if (!PlannerGlobals.outOfRoomAlertShown) {
      toastErrorSingle(ts('invalid_obj_place', 'invalidObjPlace'), false,
          'invalid-obj-place');
      PlannerGlobals.outOfRoomAlertShown = true;
    }
  } else {
    if (PlannerGlobals.outOfRoomAlertShown) {
      toastRemoveAll();
    }
    PlannerGlobals.outOfRoomAlertShown = false;

  }
  return foundValidRoom;
}

/**
 *
 * @param {D3Device} d
 */
export function dragended(event, d) {
  if (PlannerGlobals.mode == 'measureMe') {
    PlannerGlobals.panDisable = false;
    measureHelper.endMeasure(event);
    removeLengthLines();
    return;
  }
  if ($('#motionsensors').length) {
    d3.select('#motionsensors').remove();
  }
  if (PlannerGlobals.mode != 'wificalc' && $('#heatmap_fobj').length) {
    removeWifiHeatmap();
  }
  unHighlight();
  getNodeForD3Data(d).selectAll('.height-txt, .height-txt-rect').style(
      'display', '');
  PlannerGlobals.LIGHTING_CALC.stopCalculation();
  PlannerGlobals.panDisable = false;
  var dev = d.devices[0];
  var isCabinet = isDevCabinet(dev);
  var redrawAfter = false;
  var updateDone = $.Deferred();
  var similars = [];
  //const { clientX, clientY } = d3.event.sourceEvent;

  // check drag conditions
  if (PlannerGlobals.mode == 'basic' && ['rotateMe', 'groupMe'].indexOf(
          PlannerGlobals.DRAG_HELPER.dragStartMode) == -1 && !dNoPermission(d)
      && !d.haunted && !d.dragdisabled) {
    var snappedPos;

    const cursorMovedEnough = Math.pow((d.x - dev.origiposition[0]), 2)
        + Math.pow((d.y - dev.origiposition[1]), 2) > 0.01;
    const cursorIsSame = d.x == dev.origiposition[0] && d.y
        == dev.origiposition[1];

    if (!MODKEYS_STATE.shift && cursorMovedEnough) {
      const colsNum = getDColsNum(d);
      const rowsNum = getDRowsNum(d);
      const biggerDimNum = Math.max(colsNum, rowsNum);
      snappedPos = snapDeviceToNearby(d, getProductOfDevice(dev), true);
      if (!snappedPos) {
        snappedPos = snapDeviceToWall(dev,
            PlannerGlobals.DEVICE_SIZE * 1.2 + (biggerDimNum - 1)
            * PlannerGlobals.DEVICE_SIZE * 0.55, colsNum, true,
            undefined, undefined, undefined, undefined, rowsNum);
      }
      if (snappedPos && snappedPos.room.id === uDev.OUTDOORS_ROOM_ID
          && isCabinet) {
        snappedPos = false;
      }

      if (snappedPos) {
        writeDevParams(d, snappedPos.point.x, snappedPos.point.y,
            snappedPos.rotation, snappedPos.room.id);
      }
    }
    var foundValidRoom = anyRoomContainsDeviceAllpts(d);

    const overlapsValidWithSerial = d.id ? getOverlappingSerials(d) : [];
    const overlapsInvalidTooWithSerial = d.id ? getOverlappingSerials(d, true)
        : [];
    const overlapsWithSerialConn = d.connId ? getOverlappingSerials(d, true)
        : [];
    if (d.connId && overlapsWithSerialConn.length) {
      toastErrorSingle(
          ts("frm_maxtwo", 'Only two frames can be connected with each other.'),
          false, 'serconn-err');

      snapCurrDeviceBack(d);
    } else if (cursorMovedEnough && d.id && overlapsValidWithSerial.length) {
      const overlaps = getOverlappingSerials(d);
      if (overlaps.length) {
        const thisId = +d.id;
        const otherId = overlaps[0].id;
        console.log(`dragged serial ${thisId} to ${otherId}`);

        const s1 = getSerialById(thisId);
        const s2 = getSerialById(otherId);

        const canBeMerged = s1.deviceIds.length + s2.deviceIds.length <= 5;
        const canBeConnected = serialsConnectable(s1.id, s2.id);

        if (canBeMerged && canBeConnected) {
          // Both options available: hand off to the React FrameActionsDialog. It
          // calls mergeFrames/connectFrames via frameActionsActions.ts, or snaps
          // the frame back on cancel.
          _dragDropCallbacks.onFrameAction?.({
            d,
            thisId,
            otherId,
            height: s1.height,
            direction: s1.direction,
          });
        } else if (canBeMerged) {
          mergeFrames(thisId, otherId, s1.height, s1.direction);
        } else if (canBeConnected) {
          connectFrames(thisId, otherId);
        }
      }
    } else if (cursorMovedEnough && d.id && !overlapsValidWithSerial.length
        && overlapsInvalidTooWithSerial.length) {
      const closestInvalid = overlapsInvalidTooWithSerial[0];
      if (getSerialConnectionForSerialId(d.id)
          || getSerialConnectionForSerialId(closestInvalid.id)) {
        toastErrorSingle(ts("frm_maxtwo",
                'Only two frames can be connected with each other.'), false,
            'serconn-err');
      } else {
        const minDistCm = 12;
        const minDistInch = 5;
        const minDist = isPlannerMetric() ? minDistCm : minDistInch;
        const suffix = isPlannerMetric() ? "cm" : "in";

        const connErr = ts2("frm_disterr",
            "The frames can't be connected because they are too close. The minimum distance is {dist}",
            {dist: minDist + " " + suffix});
        toastErrorSingle(connErr, false, 'serconn-err');
      }

      snapCurrDeviceBack(d);
    }
    //snap back if no suitable room is found
    else if (cursorMovedEnough && !foundValidRoom && !snappedPos) {
      if (isPointOutOfBounds(d)) {
        toastErrorSingle(ts('p_dev_out_of_bounds_err',
                'Make sure the device is inside the area marked by the dashed lines.'),
            false, 'dev-place-err');
      } else {
        toastErrorSingle(ts('p_dev_wall_intersect_err',
                "Make sure the device doesn't intersect any walls."), false,
            'dev-place-err');
      }
      snapCurrDeviceBack(d);
    }
    // check if drag was further than a given threshold
    else if (cursorMovedEnough) {
      // drag was successful
      hideTools();
      if (snappedPos) {
        redrawAfter = true;
        removeErrorMarker(d);
      }
      var draggingSingleMergeds = !d.devices[0].serializable &&
          canBeDevMerged(d.devices[0])
          && d.roomId != PlannerGlobals.DRAG_HELPER.dragStartRoomId; //TODO KIDERÍTENI EZ MIÉRT KELLET

      PUTDevData(d, draggingSingleMergeds, function () {
        updateDone.resolve();
      });

      if (draggingSingleMergeds) {
        similars = PlannerGlobals.devices.filter(function (dev) {
          return dev.roomId === PlannerGlobals.DRAG_HELPER.dragStartRoomId
              && dev.product_name_id === d.devices[0].product_name_id;
        });
        redrawAfter = true;
        updateD3MergedDevs(d, PlannerGlobals.DRAG_HELPER.dragStartRoomId);
      }

      if (redrawAfter) {
        redrawD3DevExtras(d, this);
      }
    } else if (cursorIsSame) {
      d3.select(PlannerGlobals.DRAG_HELPER.draggedD3This).attr("transform",
          function (d) {
            return "translate(" + [d.x, d.y] + ")" + PlannerGlobals.DRAG_DEV_START_ROTATION;
          });
    }

    enablePlannerButtons();
    d3.select(this).style('cursor', '');
    PlannerGlobals.isDragging = false;
    PlannerGlobals.DRAG_HELPER.draggedD3Dev = null;
    PlannerGlobals.DRAG_HELPER.deviceCursorDiff = null;
    PlannerGlobals.DRAG_HELPER.draggedD3This = null;
    $(document).off('keyup', dragShiftUpHandler);
    $(document).off('keydown', dragShiftDownHandler);
    d3.select(this).classed("dragging", false);

    redrawMeasurements();

    if (DeviceDrawingGlobals.wannaRedrawAfterDrag) {
      DeviceDrawingGlobals.wannaRedrawAfterDrag = false;
      redrawDevices();
    }

  }
  if (PlannerGlobals.sizeErrorHelper.errorCorrectMode && !isInProblemDevices(
      d)) {
    addNormalModdedDev(d);
  }
  if (PlannerGlobals.sizeErrorHelper.errorCorrectMode && isInProblemDevices(d)
      && !d.hasError) {
    var count = problemDevsCount();
    if (count > 0) {
      toastRemoveAll();
      toastInfo((ts('p_devfixed', "Device fixed! Remaining:")) + " " + count);
      highlightNextProblematic();
    }
  }
  if (PlannerGlobals.sizeErrorHelper.errorCorrectMode && areProblemsFixed()) {
    enderrorCorrectMode();
  }
  var wasInMeasures = isDInMeasures(d);
  var invalidMeasures = filterInvalidMeasurements();
  if (wasInMeasures) {
    redrawMeasurementsOf(d);
  }
  PlannerGlobals.svg.selectAll('.note-tool').remove();
  $('#devicesMain')
  .find(
      '.serial-overlap-shadow-both, .serial-overlap-shadow-mrg, .serial-overlap-shadow-conn')
  .removeClass(
      'serial-overlap-shadow-both serial-overlap-shadow-mrg serial-overlap-shadow-conn');

  updateDone.done(function () {
    if (!PlannerGlobals.sizeErrorHelper.errorCorrectMode) {
      var currD3Groups = getDistinctGroupsOfDevs(uDevDOM.devicesOfD3D(d));
      showGroupInvalidMsgIfAnyIsInvalid(currD3Groups);
      recalcSwitchPNIDs();

      var historyEntry = new MoveDeviceAction(dev.deviceId,
          P_numtoxy(dev.origiposition),
          {x: d.x, y: d.y}, dev.origiRoomId, dataFromDeviceD(d).roomId,
          dev.origiAngle, d.id ? d.angle : dev.angle, invalidMeasures,
          similars);
      PlannerGlobals.plannerHistoryManager.addHistoryEntry(historyEntry);

      devicesChanged();

    }
  });
  showDragAndDropOverlay();
}

/**
 * Draw default length lines from currently dragged device
 */
export function mouseMoveDraggedDevHandler(e) {
  if (ControllerGlobals.currentlyDraggedDevice) {
    var $eTarget = e && $(e.target);
    var xy = getXYP();
    var noteXY = {
      x: uMath.clamp(xy.x, -100, 1000),
      y: uMath.clamp(xy.y, -100, 1000)
    }

    if ($eTarget && ($eTarget.closest('.serial, .serial-connected').length > 0
            || $eTarget.is('.dev-ghost'))
        && ControllerGlobals.currentlyDraggedDevice.id !== 'new_note') {
      removeGhostDevice();
      return;
    }
    if (ControllerGlobals.currentlyDraggedDevice.id === "new_note") {
      unHighlight();
      removeGhostDevice();

      var noteDevId = ($eTarget && $eTarget.hasClass('device'))
          ? $eTarget.attr('data-deviceId') : null;
      var attachToDevice = noteDevId != null && noteDevId.indexOf('S_') !== 0;
      var noteFits;

      if (attachToDevice) {
        var dev = getDeviceById(noteDevId);
        if (dev /* && PNIDHasDefaultNote(dev.product_name_id) */) {
          highlightDeviceNoZoom(noteDevId);
        }
        noteFits = true;
      } else {
        redrawGhostNote(noteXY.x, noteXY.y);
        noteFits = !!$eTarget && $eTarget.attr('data-roomId') != null;
      }

      if (document.querySelector('#plannerSVG:hover')) {
        setActiveDragPreviewState(noteFits ? DragPreviewState.INSIDE_FLOOR : DragPreviewState.OUTSIDE_FLOOR);
      }
    } else {
      removeLengthLines();
      var prodIsCam = typeof ControllerGlobals.currentlyDraggedDevice
          === "object" && ControllerGlobals.currentlyDraggedDevice &&
          ControllerGlobals.currentlyDraggedDevice.type === "device"
          && typeof ControllerGlobals.currentlyDraggedDevice.id === "string" &&
          isCamera({
            product_name_id: ControllerGlobals.currentlyDraggedDevice.id.replace(
                'product_', '')
          });

      var prodIsCabinet = typeof ControllerGlobals.currentlyDraggedDevice
          === "object" && ControllerGlobals.currentlyDraggedDevice &&
          typeof ControllerGlobals.currentlyDraggedDevice.id === "string"
          && ControllerGlobals.currentlyDraggedDevice.id.indexOf('_cabinet')
          !== -1;

      var snappedPos;

      //if (!prodIsCam) {
      if ((ControllerGlobals.currentlyDraggedDevice.id + "").match(
          /^(user_custom_item)|(product)\_/)) {
        //snappedPos = snapDeviceToWall(xy, DEVICE_SIZE * 1.5);
        snappedPos = snapDeviceToNearby(xy,
            ControllerGlobals.currentlyDraggedDevice, false);
      }
      if (!snappedPos) {
        snappedPos = snapDeviceToWall(xy, PlannerGlobals.DEVICE_SIZE * 1.5);
      }
      //}

      // redraw length from point to closest walls
      var fromPt;
      var room;
      if (snappedPos) {
        fromPt = {
          x: snappedPos.point.x + PlannerGlobals.DEVICE_SIZE / 2,
          y: snappedPos.point.y + PlannerGlobals.DEVICE_SIZE / 2
        };
        room = snappedPos.room;
      } else {
        fromPt = xy;
        room = whichRoomIsPointInInclOutdoorsAndUnassigned(xy);
      }

      var doesFit = snappedPos || room && doesDeviceFitRoom(room.id, {
        x: xy.x - PlannerGlobals.DEVICE_SIZE / 2,
        y: xy.y - PlannerGlobals.DEVICE_SIZE / 2
      }, 0, 1);

      if (prodIsCabinet && room && room.id === uDev.OUTDOORS_ROOM_ID) {
        snappedPos = null;
        doesFit = false;
      }

      if (document.querySelector('#plannerSVG:hover')) {
        setActiveDragPreviewState(doesFit ? DragPreviewState.INSIDE_FLOOR : DragPreviewState.OUTSIDE_FLOOR);
      }

      if (snappedPos) {
        redrawGhostDevice(snappedPos.point, snappedPos.rotation,
            snappedPos.room);
      } else {
        removeGhostDevice();
      }
      if (ControllerGlobals.currentlyDraggedDevice.mergeable === true) {
        $('.productId'
            + ControllerGlobals.currentlyDraggedDevice.product_id).addClass(
            'merged-highlight');
      }

      if (snappedPos && snappedPos.measureLinePtPairs) {
        drawSnapLines(snappedPos.measureLinePtPairs);
      } else if (room && room.id != uDev.OUTDOORS_ROOM_ID && room.id
          != uDev.UNASSIGNED_ROOM_ID) {
        var walls = twoClosestWallsWithPoints(fromPt, room);
        for (var i = 0; i < 2; i++) {
          if (walls[i] && walls[i].closestPt) {
            drawLengthLine(fromPt, walls[i].closestPt);
          }
        }
      }
    }
  }
}

export function showDragAndDropOverlay(show) {

  // TEMPORARY OVERRIDE: always hide overlay
  show = false;

  if (show === undefined) {

    let cropButtons = document.getElementById('planner-buttons-crop');
    let cropVisible = cropButtons && !!(cropButtons.offsetWidth
        || cropButtons.offsetHeight || cropButtons.getClientRects().length);

    // TODO: moveplannercode-deadcode
    // First-ever-project onboarding overlay (temporarily disabled in legacy).
    // Not relevant for the new UI flow; tracked in a separate issue.
    let isOnlyOneProject = false;

    show = PlannerGlobals.mode == 'basic'
        && !cropVisible
        && !globalNeedToSetTheScale && PlannerGlobals.lastRatioPoints
        && PlannerGlobals.isScaleChecked
        && isOnlyOneProject
        && floorProvider.getFloorCount() === 1
        && PlannerGlobals.devices.length == 0
        && PlannerGlobals.notes.length == 0
    ;
  }

  const overlay = document.getElementById('planner-overlay');
  // New UI can unmount the canvas (e.g. all floor accordions collapsed) while the
  // global ESC handler is still bound, so #planner-overlay may not exist.
  if (!overlay) return;
  overlay.style.display = show ? 'block' : 'none';
  $('#device_tree').removeClass('highlighted');
  if (show) {
    $('#reset-center-btn').trigger('click');
  }
}